import { PlusOutlined, SearchOutlined, SettingOutlined } from '@ant-design/icons';
import { ColDef } from 'ag-grid-community';
import { Breadcrumb, Button, ConfigProvider, Flex, Input, Pagination, Select } from 'antd';
import viVN from 'antd/locale/vi_VN';
import React, { useEffect, useMemo, useState } from 'react';
import Layout from '../../../Layout';
import * as SelectOptionApi from '../../../api/selectOptions/selectOptionsApi';
import * as UnitApi from '../../../api/unit/unitApi';
import ModalDeleteManager from '../../../components/ModalDeleteManager';
import useDebounce from '../../../hook/useDebounce';
import useLoading from '../../../hook/useLoading';
import useToast from '../../../hook/useToast';
import { checkDisabledPermission, dataPagination, flattenDonViArray, fommatSelectOption, getUserPermissions } from '../../../until';
import DrawerAddvance from '../../VehicleManagement/VehicleList/Component/Drawer/DrawerAddvance';
import ModalCreateUnit from './Modal/ModalCreateUnit';
import ModalEditUnit from './Modal/ModalEditUnit';
import TableCustomTypeTree from './TableCustomTypeTree';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectorPermission } from '../../../store/slices/permissionSlice';
import { getListRegion } from '../../../api/selectOption/selectOptionsApi';
import { selectorInfoUser } from '../../../store/slices/infoUserSlice';

const Units: React.FC = () => {
  const pushToast = useToast();
  const pushLoading = useLoading();
  const location = useLocation();
  const permissionSlice = useSelector(selectorPermission)
  const { unitTemp } = useSelector(selectorInfoUser)
  const { add, edit, delete: isdelete, } = getUserPermissions(permissionSlice, location.pathname)

  const [openCreateUnit, setOpenCreateUnit] = useState(false);
  const [openEditUnit, setOpenEditUnit] = useState(false);
  const [openDeleteUnit, setOpenDeleteUnit] = useState(false);
  const [isOpenAddvance, setIsOpenAddvance] = useState(false);
  const [selectedIdUnit, setSelectedIdUnit] = useState<Set<Number>>(new Set());


  const [search, setSearch] = useState<string>();
  const [id, setId] = useState<number>();
  const [dataUnit, setDataUnit] = useState<UnitApi.DataTypeUnitV2[]>([]);
  const [sLRegionId, setSLRegionId] = useState<SelectOptionApi.ISelectOption[]>([])
  const [listRegion, setListRegion] = useState<number[]>([])


  const [dataConvert, setDataConvert] = useState<SelectOptionApi.dataConvert[]>([]);
  const [dataListNationwide, setDataListNationwide] = useState<any>();
  const [dataListNationwideCreate, setDataListNationwideCreate] = useState<any>();

  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });

  const defaultColumnsShow = ['action', 'code', 'b7EntityCode', 'title', 'nationwideTitle', 'regionTitle', 'status'] as any;

  const drawerColumnDefs = useMemo<ColDef<any>[]>(() =>
    [
      { headerName: 'Hành động', colId: 'action' },
      { headerName: 'Mã đơn vị', colId: 'code' },
      { headerName: 'Mã pháp nhân B7', colId: 'b7EntityCode' },
      { headerName: 'Đơn vị', colId: 'title' },
      { headerName: 'Toàn quốc', colId: 'nationwideTitle' },
      { headerName: 'Vùng miền', colId: 'regionTitle' },
      { headerName: 'Trạng thái', colId: 'status' },
    ]
    , []);

  const [visibleColumns, setVisibleColumns] = useState<string[]>(() => {
    const saved = localStorage.getItem('unitListColums');
    return saved ? JSON.parse(saved) : [...defaultColumnsShow];
  });

  const getSLRegionId = async () => {
    // const result = await getListRegion(unitTemp)
    const result = await getListRegion()
    if (result?.status) {
      setSLRegionId(fommatSelectOption(result.data))
    } else {
      //   pushToats(result?.message, "warning")
    }
  }

  const gListUnit = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    pushLoading(true);
    const result = await UnitApi.getListUnitV2(pageSize, pageCurent, search, listRegion);
    if (result?.status) {

      setDataUnit(result.data);
      setPagination({ current: pageCurent, total: result.total, pageSize });
    } else {
      pushToast(result?.message, 'error');
    }
    pushLoading(false);
  }, 1000);

  function convertNationwide(data: UnitApi.OptionSelect[], id: number) {
    return data
      .filter((value) => value.value !== id)
      .map((item) => {
        const treeItem: UnitApi.OptionSelect = {
          value: item.value,
          label: `${item.label}`,
          title: item.title,
          children: [],
        };
        if (item.children != null && item.children.length > 0) {
          treeItem.children = convertNationwide(item.children, id);
        }
        return treeItem;
      });
  }

  const gListNationwide = useDebounce(async () => {
    const result = await SelectOptionApi.getListNationwide();
    if (result?.status) {
      setDataConvert(flattenDonViArray(result.data));
      setDataListNationwide(UnitApi.convertNationwideValueToTree(result.data));
      setDataListNationwideCreate(UnitApi.convertNationwideValueToTree(result.data));
    } else {
      pushToast(result?.message, 'error', 2000);
    }
  }, 1000);

  // const convertData = (data: UnitApi.IUnit[], pageCurent: number, pageSize: number) => {
  //   const convertData = data.map((item) => ({
  //     codeUnit: item.code,
  //     unit: item.title,
  //     nationwide: '',
  //     region: '',
  //     key: item.id,
  //     parentId: item.parentId,
  //     view: item.view,
  //     b7EntityCode: item.b7EntityCode,
  //     regionTitle: item?.regionTitle,
  //     nationwideTitle: item?.nationwideTitle
  //   }));
  //   return convertData;
  // };

  const onSubmitFormModalAdd = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {
      setOpenCreateUnit(false)
      pushToast(message, "success")
      gListUnit(pagination.current, pagination.pageSize)
    } else {
      pushToast(message, "error")
    }
  }

  const onSubmitFormModalEdit = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {
      setOpenEditUnit(false)
      pushToast(message, "success")
      gListUnit(pagination.current, pagination.pageSize)
    } else {
      pushToast(message, "error")
    }
  }


  const onPaginationChange = (current: number, pageSize: number) => {
    setPagination((prev) => ({ ...prev, current, pageSize }));
    gListUnit(current, pageSize);
  };

  const updateActiveUnit = async (id: number) => {
    const result = await UnitApi.updateActiveUnit(id);
    if (result?.status) {
      gListUnit(pagination.current, pagination.pageSize);
      pushToast(result?.message, 'success', 2000);
    } else {
      pushToast(result?.message, 'error', 2000);
    }
  };

  const handleDelete = async () => {
    if (id) {
      const result = await UnitApi.deleteActiveNationwide(id);
      if (result?.status) {
        gListUnit(pagination.current, pagination.pageSize);
        setOpenDeleteUnit(false);
        pushToast('Xóa đơn vị thành công!', 'success', 2000);
      } else {
        pushToast(result?.message, 'error', 2000);
      }
    }
  };

  const handleCloseSetting = (value: any, isChange: boolean, _reorderedColumns: any[]) => {
    if (isChange) {
      localStorage.setItem('unitListColums', JSON.stringify(value));
      setVisibleColumns(value);
    }
    setIsOpenAddvance(false);
  };

  useEffect(() => {
    document.title = 'THACO AUTO CRM';

    gListNationwide();
  }, [search]);

  useEffect(() => {
    if (id) {
      setDataListNationwide(convertNationwide(dataListNationwideCreate, id));

    }
  }, [id, openEditUnit, id]);

  useEffect(() => {
    getSLRegionId()

  }, [unitTemp])

  useEffect(() => {
    gListUnit();

  }, [unitTemp, search, listRegion])

  return (
    <Layout>
      <ModalCreateUnit
        isOpen={openCreateUnit}
        dataListNationwide={dataListNationwideCreate}
        onSubmitFormModal={onSubmitFormModalAdd}
        closeModal={() => setOpenCreateUnit(!openCreateUnit)}
      />
      <ModalEditUnit
        dataListNationwide={dataListNationwide}
        id={id}
        onSubmitFormModal={onSubmitFormModalEdit}
        isOpen={openEditUnit}
        closeModal={() => setOpenEditUnit(!openEditUnit)}
      />
      <ModalDeleteManager
        isOpen={openDeleteUnit}
        onConfirm={handleDelete}
        closeModal={() => setOpenDeleteUnit(!openDeleteUnit)}
        title="Bạn có chắc chắn xóa đơn vị này"
        titleDelete="Xóa đơn vị"
        content="Đơn vị và dữ liệu liên quan sẽ bị xóa vĩnh viễn không thể khôi phục"
      />
      <DrawerAddvance
        isOpen={isOpenAddvance}
        columns={drawerColumnDefs}
        defaultColumnsShow={defaultColumnsShow}
        localStorageValue="unitListColums"
        onClose={(value, isChange, reorderedColumns) => handleCloseSetting(value, isChange, reorderedColumns)}
        closeDrawer={() => setIsOpenAddvance(!isOpenAddvance)}
      />
      <Breadcrumb
        items={[
          {
            title: 'THACO AUTO CRM',
          },
          {
            title: <a href="/">Danh mục đơn vị</a>,
          },
          {
            title: 'Đơn vị',
          },
        ]}
      />
      <div className="title-page">Đơn vị</div>
      <Flex vertical className="gap-18px">
        <Flex align="start" className="gap-10px">
          <p className="text-base font-medium text-344054 white-space-nowrap">Danh sách đơn vị</p>
          <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center pl-3 py-1 h-8 justify-between overflow-hidden">
            <Input
              placeholder="Tìm kiếm"
              className="bg-FCFCFD text-sm border-none custom-input-focus none-focus-erro font-regular p-none-input place-holder-input-667085 hover-none"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <div className="border-l-F2F4F7 h-full d-flex align-center">
              <SearchOutlined className="text-sm text-98A2B3 px-9-px" />
            </div>
          </div>
          <div className="w-300-px">
            <Select
              allowClear
              mode='multiple'
              placeholder="Chọn vùng miền"
              className="custom-select-mutiple-v2"
              options={sLRegionId}
              onChange={(e) => setListRegion(e)}
              popupMatchSelectWidth={false}
            />
          </div>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            className={`rs-button rs-button--sm   ${checkDisabledPermission(add)}`}
            onClick={() => setOpenCreateUnit(true)}
          >
            Tạo mới
          </Button>
          <button
            className="border-EAECF0 bg-white rounded-2 w-8 h-8 shadow-btn-save"
            onClick={() => setIsOpenAddvance(true)}
          >
            <SettingOutlined className="text-sm text-344054" />
          </button>
        </Flex>
      </Flex>


      <div className={`order-history-card__body custom-page-css flex flex-col flex-1 justify-between pt-4`}>
        <div className="ag-theme-alpine  custom-table-ag" style={{ width: '100%', height: 610 }}>

          <TableCustomTypeTree
            dataTable={dataUnit}
            selectedIdUnit={selectedIdUnit}
            setSelectedIdUnit={setSelectedIdUnit}
            updateActiveUnit={updateActiveUnit}
            setId={setId}
            setOpenDeleteUnit={setOpenDeleteUnit}
            setOpenEditUnit={setOpenEditUnit}
            visibleColumns={visibleColumns}
          />
        </div>

        {/* Pagination */}
        <ConfigProvider locale={viVN}>
          <div className="pagination-block">
            <Pagination
              showSizeChanger
              current={pagination.current}
              pageSize={pagination.pageSize}
              total={pagination.total}
              showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, pagination.current).totalPage} trang`}
              className='rs-pagination'
              onChange={onPaginationChange}
            />
          </div>
        </ConfigProvider>
      </div>
      {/* <div className="ag-theme-alpine custom-table-ag custom-css-table" style={{ width: '100%', height: 610 }}>
          <AgGridReact
            className="my-auto-height-grid"
            getRowStyle={(params: any) => ({
              backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
            })}
            rowData={dataUnit}
            rowHeight={55}
            columnDefs={columnDefsWithVisibility}
            rowSelection={{ mode: 'multiRow' }}
            // rowSelection="multiple"
            overlayNoRowsTemplate={NodataTable}
            suppressDragLeaveHidesColumns={true}
          />

        </div>
        <ConfigProvider locale={viVN}>
          <div className="pagination-block">
          
          </div>
        </ConfigProvider> */}
    </Layout>
  );
};

export default Units;
